module.exports = __webpack_public_path__ + "static/img/slide1.3fb0805.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/original-slides/slide1.jpg
// module id = gHBA
// module chunks = 1